import type { Dictionary } from 'asap-team/asap-tools';

export const TRACKING_PROVIDER: Dictionary = {
  GA: 'google_analytics',
  GTM: 'google_tag_manager',
  FB: 'facebook_pixel',
};
export const DEFAULT_EVENT_CATEGORY: string = 'HER Stepper';
